export default {
  formatValue(value) {
    return (value !== null) && (value !== undefined) && value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }) || undefined;
  },
};
